/**
 * Holds info about the supported external search APIs
 */
export interface ExternalImageSearchApiConfig {
  /**
   * The key is a short-term for the service used, i.e. 'flickr' for FLickr. Should not change!
   */
  [key: string]: {
    /**
     * The name of the API as shown in texts
     */
    name: string;
    /**
     * The API endpoint
     */
    url: string;
    /**
     * A public key if necessary
     */
    publicKey?: string
  };
}

/**
 * The actual config for external image search apis
 */
export const ExternalImageSearchApis: ExternalImageSearchApiConfig = {
  cc: {
    name: 'Openverse Image Search',
    url: '/api/openverse/v1/images/'
  },

  flickr: {
    name: 'Flickr Public Image Search',
    url: 'https://www.flickr.com/services/rest/',
    publicKey: 'bc74556d96120702fa64809ce374042c'
  }
  // Add other APIs here if needed in the future
};
